import { Box } from '@material-ui/core';
import { CheckoutSessionStatus } from '@nemuru-eng/js-api-client';
import { ReactNode } from 'react';

import { ApplicationSummary } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/ApplicationSummary';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useScreen } from '@/hooks/useScreen';

interface ApplicationSummaryWrapperProps {
  children: ReactNode;
  loading?: boolean;
  checkoutSessionStatus?: CheckoutSessionStatus;
  forceShowSummaryOnDesktop?: boolean;
  showSectionTitle?: boolean;
}
export const ApplicationSummaryWrapper = ({
  children,
  loading = false,
  checkoutSessionStatus,
  forceShowSummaryOnDesktop,
  showSectionTitle = true,
}: ApplicationSummaryWrapperProps) => {
  const { md, lg } = useScreen();

  const {
    state: { showLeftMenu },
  } = usePageContext();

  const {
    state: { showSummary },
  } = useApplicationContext();

  const mobileVersion = !(lg || (md && (!showLeftMenu || forceShowSummaryOnDesktop)));

  const isDesktopSummaryVisible = showSummary && !mobileVersion;
  const summaryWidth = isDesktopSummaryVisible ? 380 : 0;
  const gap = !showSummary ? 0 : lg ? 64 : md ? 32 : 0;

  return (
    <Box position="relative">
      <Box paddingRight={`${summaryWidth + gap}px`} style={{ transition: 'padding-right 0.5s ease-in-out' }}>
        {children}
      </Box>
      <Box
        position={'absolute'}
        right={isDesktopSummaryVisible ? '0' : `-${summaryWidth + gap + 10}px`}
        top={0}
        width={summaryWidth}
        style={{ transition: 'all 0.5s ease-in-out' }}
      >
        <ApplicationSummary
          loading={loading}
          checkoutSessionStatus={checkoutSessionStatus}
          forceShowSummaryOnDesktop={forceShowSummaryOnDesktop}
          showSectionTitle={showSectionTitle}
        />
      </Box>
    </Box>
  );
};
